import { Button, ModalV1 } from '@p2p/components';

import { DisputeInput } from '../DisputeInput';
import styles from './DisputeConfirmModal.module.scss';
import type { DisputeConfirmModalProps } from './DisputeConfirmModal.types';

export const DisputeConfirmModal = ({
  active,
  setActive,
  status,
  sumOrder,
  sum,
  sumRegister,
  onSubmit,
}: DisputeConfirmModalProps) => {
  if (!active) return null;

  return (
    <ModalV1 active={active} setActive={setActive}>
      <div className={styles.textForModal}>
        <span>
          {status === 'TO' ? 'По сделке вышло время.' : 'Сделка уже успешна!'} Сумма {sumOrder}
        </span>
        <p>Вы уверены, что хотите создать спор для пересчета сделки?</p>
        <DisputeInput
          register={sumRegister}
          type="number"
          title="Комментарий"
          placeholder="Введите сумму"
        />
        <div className={styles.btn__container}>
          <Button
            variant="v1-outlined"
            className={styles.btn__cancel}
            onClick={() => setActive(false)}
          >
            {status === 'TO' ? 'Отмена' : 'Нет'}
          </Button>
          <Button variant="v1" className={styles.btn__send} onClick={onSubmit} disabled={!sum}>
            {status === 'TO' ? 'Отправить' : 'Да'}
          </Button>
        </div>
      </div>
    </ModalV1>
  );
};
